export function getStoredAuth() {
  try {
    const raw = localStorage.getItem('flowra_auth');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredAuth(auth) {
  if (!auth) {
    localStorage.removeItem('flowra_auth');
  } else {
    localStorage.setItem('flowra_auth', JSON.stringify(auth));
  }
}
